import { isStatedFreeOfCharge, resolveItemPricing, type PricedLine } from '../../utils/pricing';
import type { ClientInvoiceItemDto } from '../../lib/clientInvoiceApi';

/**
 * D152.3: what the client was QUOTED for an order-derived line, read from the order line (never the
 * invoice line, which a person may have edited). The drawer prints it read-only; nothing is stored.
 *   null          = not an order line (manual, vendor-bill, additional invoice): no section.
 *   'unavailable' = an order line whose order line is not here (order not loaded, 403, position gone).
 * The price is worked out exactly as the invoice build prices the line (`buildClientInvoiceItems`:
 * a stated 0 is free of charge, else the stored selling price, else the house markup) and is shown
 * in the ORDER LINE's own currency, never the invoice's. The remark is `remarks` only, never `internalRemarks`.
 */
export type QuoteInfo = { unit: string; priceText: string; remark: string } | 'unavailable' | null;

export type QuotedOrderLine = PricedLine & { uom?: string | null; currency?: string | null; remarks?: string | null };

export const quoteInfoFor = (
  item: Pick<ClientInvoiceItemDto, 'confirmedOrderItemIndex'>,
  orderLine: QuotedOrderLine | null | undefined,
  money: (value: number | null | undefined, currency?: string) => string
): QuoteInfo => {
  if (item.confirmedOrderItemIndex == null) return null;
  if (!orderLine) return 'unavailable';
  const unitPrice = resolveItemPricing(orderLine).unitSellingPrice;
  return {
    unit: (orderLine.uom || '').trim() || '-',
    priceText: isStatedFreeOfCharge(orderLine) ? 'Free of charge' : unitPrice > 0 ? money(unitPrice, orderLine.currency || '') : '-',
    remark: (orderLine.remarks || '').trim() || '-',
  };
};
